export default __webpack_public_path__ + "static/PMG_EGIB_HOHH_PDS_AGENCY_BM-475b1fa853db5fc293a738cb89520a2d.pdf";